import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const HomeScreen = () => {
  return (
    <Container fluid className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="text-center">
            <Card.Body>
              <h1>Welcome to Your Dashboard</h1>
              <p>Your all-in-one platform to manage and track everything you need!</p>
              <Button variant="primary" href="/dashboard" size="lg">
                Go to Your Dashboard
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={4}>
          <Card>
            <Card.Body>
              <h5>What’s New</h5>
              <p>Stay updated with the latest changes, updates, and new features.</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card>
            <Card.Body>
              <h5>Quick Access</h5>
              <p>Easy links to the most used features of your dashboard.</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card>
            <Card.Body>
              <h5>Support</h5>
              <p>Need help? Visit our support section for FAQs and contact info.</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default HomeScreen;
